import { ITasklistProcess, TasklistService } from '@/api/tasklist';
import BusinessProcessItem from '@/components/ui/BusinessProcessItem';
import { Input } from 'alurkerja-ui';
import { useEffect, useState } from 'react';
import { UserService } from '@/api/user';

export const Home = () => {
  const { data: profile } = UserService.useGetProfile();
  const { data: businessProcesses, isFetching: isFetchingBusinessProcesses } = TasklistService.useGetProcesses({
    username: profile?.username,
  });
  const [filteredBusinessProcesses, setFilteredBusinessProcesses] = useState<ITasklistProcess[]>(
    businessProcesses ?? [],
  );

  useEffect(() => {
    setFilteredBusinessProcesses(
      businessProcesses?.filter(item => {
        if (profile?.role?.toLowerCase().includes('manager')) {
          return true;
        }
        return item.key !== 'Pengajuan-pemantauan-KPI-GRD';
      }) ?? [],
    );
  }, [businessProcesses, profile]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value.toLowerCase();
    const filtered = businessProcesses?.filter(item => {
      const itemName = item.name?.toLowerCase();
      return itemName?.includes(searchValue) || false;
    });
    setFilteredBusinessProcesses(filtered ?? []);
  };

  if (isFetchingBusinessProcesses) return <div>Loading...</div>;

  return (
    <div className="flex flex-col items-center py-10 px-4 space-y-10">
      <div className="w-full flex">
        <div className="flex w-full justify-center">
          <Input
            placeholder="Search..."
            onChange={handleSearch}
            name="search"
            className="max-w-[500px] border-0 shadow"
          />
        </div>
      </div>
      <div className="w-full max-w-[1000px]">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-6 lg:gap-10">
          {filteredBusinessProcesses?.map((item, index) => (
            <BusinessProcessItem key={index} businessProcess={item} />
          ))}
        </div>
      </div>
    </div>
  );
};
